__turbopack_context__.v({
  "equalizer_container": "Equalizer-module-scss-module__we5d9G__equalizer_container",
});
